module.exports = __webpack_public_path__ + "static/media/Group.60ee090a.svg";